export default {
  appEnv: import.meta.env.VITE_APP_ENV || 'local',
  appTitle: import.meta.env.VITE_APP_TITLE || 'OE Service Operations Portal',
  authDomain: import.meta.env.VITE_AUTH0_DOMAIN || '',
  authClientId: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
  authClientSecret: import.meta.env.VITE_AUTH0_CLIENT_SECRET || '',
  auth0Audience: import.meta.env.VITE_AUTH0_AUDIENCE || '',
  baseUrl: import.meta.env.VITE_BASE_URL || window.location.origin,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '',
  wpBaseUrl: import.meta.env.VITE_CP_BASE_URL || '',
  ybug: {
    projectId: import.meta.env.VITE_YBUG_PROJECT_ID || undefined,
  },
  buildBranch: import.meta.env.VITE_BRANCH || '-',
  buildCommit: import.meta.env.VITE_COMMIT_REF || '-',
  buildTag: import.meta.env.VITE_TAG || false,
  buildTime: import.meta.env.VITE_BUILD_TIME || '-',
  posthog_api_host_url: { api_host: 'https://eu.posthog.com' },
  posthog_api_key: import.meta.env.VITE_POSTHOG_API_KEY || '',
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN || '-',
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
  },
  pusher: {
    enabled: import.meta.env.VITE_PUSHER_ENABLED || false,
    app: import.meta.env.VITE_PUSHER_APP_ID || '-',
    key: import.meta.env.VITE_PUSHER_KEY || '-',
    cluster: import.meta.env.VITE_PUSHER_CLUSTER || '-',
  },
  chargeBeeUrl: import.meta.env.VITE_CHARGEBEE_SITE || '-',
  seasonalEffect: import.meta.env.VITE_SEASONAL_EFFECT,
};
